<template>
  <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="inline-block mr-2 -ml-2">
    <g class="transition-transform duration-200 transform translate-x-2 group-hover:translate-x-0 group-hover:transform">
      <path d="M 6.679688 0.195312 L 1.121094 5.847656 L 2.496094 7.242188 L 8.050781 1.589844 Z M 8.050781 10.066406 L 4.785156 6.742188 L 3.414062 8.136719 L 6.683594 11.460938 Z M 8.050781 10.066406" fill="black" />
    </g>
    <path
      class="transition-transform duration-200 origin-right transform scale-x-0 group-hover:transform group-hover:scale-x-100"
      d="M 6.957031 7.023438 L 14.8125 7.023438 L 14.8125 5.050781 L 6.957031 5.050781 L 5.964844 6.039062 Z M 6.957031 7.023438"
      fill="black" />
  </svg>
</template>

<script>
export default {
  name: 'EllevioWebLinkIconLeftSmall'
}
</script>
